module.exports = __webpack_public_path__ + "static/media/6h_website_logo_Platinum_arup.70bc6e2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/6h_website_logo_Platinum_arup.jpg
// module id = 103
// module chunks = 0